export function openOverlayMenu()
{
  let burgerMenuButton = document.getElementById('burger-menu');
  let closeMenuButton = document.getElementById('close-menu');
  let menuOverlay = document.getElementById('menu-overlay');

  if(burgerMenuButton) {
    burgerMenuButton.addEventListener('click', function () {
      menuOverlay.classList.add('is-open')
      document.body.classList.add('is-fixed');
    })
  }

  if(closeMenuButton) {
    closeMenuButton.addEventListener('click', function () {
      menuOverlay.classList.remove('is-open')
      document.body.classList.remove('is-fixed');
    })
  }
}

export function openOverlaySubmenu()
{
  let items = document.querySelectorAll('.menu-overlay .item-overlay')

  items.forEach((item) => {
    let i = 0;
    item.addEventListener('click', function (e) {
      i++;

      if(item.parentElement.classList.contains('has-children')) {
        e.preventDefault();
      }

      // Close all submenu opened
      let currentItemSubmenu = document.querySelector('.menu-overlay [data-id="' + item.getAttribute('id') + '"]');
      let submenuOpened = document.querySelectorAll('.sub-menu.is-open')

      submenuOpened.forEach((sub) => {

        if (sub.getAttribute('data-id') !== item.getAttribute('id')) {
          item.classList.remove('is-open')
          sub.classList.remove('is-open')
          item.removeAttribute('count')
        }
      })

      if (item.getAttribute('count') >= 1) {
        i = 0;
        item.classList.remove('is-open')
        currentItemSubmenu.classList.remove('is-open')
        item.removeAttribute('count')
      } else {
        item.setAttribute('count', i);
        item.classList.toggle('is-open')
        currentItemSubmenu.classList.toggle('is-open');
      }

    })
  })
}

export function fixedNavbar()
{
  let header = document.getElementById('header-fixed');
  let headerHeight = header.offsetTop;
  let distanceAfterSticky = 800;
  let scrollPage = document.documentElement.scrollTop;

  if (scrollPage > headerHeight && scrollPage < distanceAfterSticky) {
    header.style.transform = 'translateY(-100%)'
  } else {
    header.style.transform = 'translateY(0%)'
  }

  if (scrollPage > distanceAfterSticky && scrollPage > headerHeight) {
    header.classList.add('is-fixed')
  }

  if(scrollPage < 800 - 300) {
    header.classList.remove('is-fixed');
    header.style.transform = 'translateY(0%)'
  }
}

